import { DataTable } from "lib/@components/data-table/data-table"
import { DuplicateFinderRow } from "./duplicate-finder-row"

export function DuplicateFinderTable({ results }) {
    const rows = results.map(toRow)
    const columns = buildColumns()

    return (
        <DataTable
            columns={columns}
            RowComponent={<DuplicateFinderRow />}
            items={rows}
            keyFn="id"
            sortKey="duplicate-finder-sort"
            pageSizeKey="duplicate-finder-page-size"
            defaultSort={{ field: "similarity", descending: true }}
            itemLabel="pairs"
        />
    )

    function toRow(item) {
        const [keyA, keyB] = item.pair ?? []
        return { id: `${keyA}-${keyB}`, keyA, keyB, similarity: item.similarity }
    }

    function buildColumns() {
        return [
            { field: "keyA", label: "Ticket A", sortable: true },
            { field: "keyB", label: "Ticket B", sortable: true },
            { field: "similarity", label: "Similarity", sortable: true, align: "right", width: 120 },
        ]
    }
}
